import { useTheme } from "@mui/material/styles";

const SafetyMenuIconFilled = () => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill={theme.palette.primary.main} />
      <g clipPath="url(#clip0_28738_536)">
        <path
          d="M25.0414 20.1381H24.5929V18.498C24.5929 14.969 22.4022 11.7685 19.1259 10.4847V10.09C19.1259 9.46913 18.6207 8.96399 17.9999 8.96399H13.9776C13.3568 8.96399 12.8517 9.46913 12.8517 10.09V10.4847C9.57516 11.7685 7.38468 14.9693 7.38468 18.4982V20.1384H6.93596C6.48043 20.1381 6.10986 20.5089 6.10986 20.9644V22.1872C6.10986 22.6428 6.48043 23.0133 6.93596 23.0133H25.0414C25.4969 23.0133 25.8677 22.6428 25.8677 22.1872V20.9644C25.8677 20.5089 25.4971 20.1381 25.0414 20.1381ZM7.82374 18.4982C7.82374 15.2072 9.83136 12.217 12.8517 10.9584V13.9094C12.8517 14.0306 12.95 14.1289 13.0712 14.1289C13.1924 14.1289 13.2907 14.0306 13.2907 13.9094V10.6362V10.09C13.2907 9.71127 13.599 9.40305 13.9776 9.40305H15.7692V16.0621C15.7692 16.1833 15.8676 16.2816 15.9888 16.2816C16.1099 16.2816 16.2083 16.1833 16.2083 16.0621V9.40305H17.9999C18.3788 9.40305 18.6868 9.71127 18.6868 10.09V10.6359V13.9092C18.6868 14.0303 18.7849 14.1287 18.9063 14.1287C19.0277 14.1287 19.1259 14.0303 19.1259 13.9092V10.9582C22.1462 12.2168 24.1538 15.207 24.1538 18.498V20.1381H7.82374V18.4982ZM25.4286 22.1872C25.4286 22.4006 25.255 22.5743 25.0414 22.5743H6.93596C6.72257 22.5743 6.54893 22.4006 6.54893 22.1872V20.9644C6.54893 20.7508 6.72257 20.5772 6.93596 20.5772H7.60399H24.3733H25.0414C25.255 20.5772 25.4286 20.7508 25.4286 20.9644V22.1872Z"
          fill="white"
          stroke="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_28738_536">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SafetyMenuIconFilled;
